<template>
	<div>
		<!-- <ShareInvoiceModal :show_share_invoice.sync="modals.show_share_invoice" /> -->
		<el-drawer :modal="false" :visible="is_visible" class="drawer-invoice-table" size="45%" @close="hide">
			<template slot="title">
				<div class="d-flex justify-content-between align-items-center">
					<h3 class="font-weight-600">{{ is_update ? 'Edit' : 'Create' }} Pro Forma Invoice</h3>
					<div class="d-flex align-items-center mx-2" v-if="is_update">
						<div class="d-flex align-items-center mx-2 text-primary cursor-pointer" @click="generatePdf()">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
								<path fill="currentColor"
									d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
							</svg>
							<p class="text-xs mx-1 text-primary">Preview</p>
						</div>
						<!-- <div class="d-flex align-items-center text-primary cursor-pointer"
							@click="modals.show_share_invoice = true">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
								<path fill="currentColor"
									d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 0 0-34.4-5.4z" />
							</svg>
							<p class="text-xs mx-1 text-primary">Share</p>
						</div> -->
					</div>
				</div>
			</template>

			<b-container>
				<ValidationObserver v-slot="{ invalid }" ref="observer">
					<b-form role="form" @submit.prevent="submit()">
						<div class="d-flex justify-content-between">
							<b-form-group label="Select a Customer" style="width: 200px;">
								<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'customerId'">
									<el-select v-model="invoiceForm.inv_user_id" filterable remote reserve-keyword :disabled="is_update"
										placeholder="Please enter customer" :remote-method="remoteMethod" :loading="is_loading_opt"
										value-key="customer_id" required>
										<el-option v-for="(customer, index) in customerOptions" :key="index" :label="customer.name"
											:value="customer.customer_id">
										</el-option>
									</el-select>
									<!-- <small class="bg-success w-auto">si Wakak</small> -->
									<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
								</ValidationProvider>
							</b-form-group>
							<b-form-group label="Issue Date" style="width: 200px;">
								<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'issuedDate'">
									<el-date-picker type="datetime" placeholder="Pick a Date" v-model="invoiceForm.inv_issued_date" :disabled="is_update"
										value-format="yyyy-MM-dd hh:mm:ss" required>
									</el-date-picker>
									<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
								</ValidationProvider>
							</b-form-group>
						</div>

						<div class="d-flex justify-content-between mb-0" v-if="is_update">
							<div>
								<h4>Selected Customer Detail</h4>
								<p class="text-primary">{{ invoiceForm.inv_user_name }} </p>
								<p>{{ invoiceForm.inv_user_email != 0 ? invoiceForm.inv_user_email : 'n/a' }} </p>
								<p>{{ invoiceForm.inv_user_mobile != 0 ? invoiceForm.inv_user_mobile : 'n/a' }} </p>
							</div>
						</div>

						<b-form-group label="" label-cols="12" content-cols="12" v-if="is_update">
							<b-input-group class="mb-2" v-if="!_gHlp.isEmpty(paymentDetail)">
								<b-form-input :value="paymentDetail.pay_url" type="text" readonly></b-form-input>
								<b-input-group-append>
									<b-button variant="primary" type="button" class="px-5"
										@click="_gHlp.copyToClipboard(paymentDetail.pay_url)">
										<b-icon icon="files" aria-hidden="true"></b-icon>
										Copy
									</b-button>
									<b-button variant="warning" type="button" class="px-5" @click="sendToEmail()" :disabled="is_loading_btn">
										<b-icon icon="share" aria-hidden="true"></b-icon>
										Email
									</b-button>
								</b-input-group-append>
							</b-input-group>
							<b-button v-else variant="primary" type="button" class="w-100" @click="generatePayment()"> Generate
								Payment Link</b-button>
						</b-form-group>

						<hr class="hr">

						<h3>Invoice Item Details</h3>

						<div class="table-listings input-table">
							<b-table-simple bordered class="table-listings input-table">
								<b-thead>
									<b-tr style="border: #252938;">
										<b-th width="35%" style="background-color: #252938;" class="text-white">Type</b-th>
										<b-th width="35%" style="background-color: #252938;" class="text-white">List Of Profesional Service</b-th>
										<b-th style="min-width: 35%; background-color: #252938;" class="text-white">Description</b-th>
										<b-th width="25%" style="background-color: #252938;" class="text-white">Amount (RM)</b-th>
										<b-th style="background-color: #252938;"></b-th>
									</b-tr>
								</b-thead>
								<b-tbody>
									<b-tr v-for="(inv_item, index) in invoiceForm.inv_items" :key="index">
										<b-td class="p-0 m-0">
											<!-- <el-input placeholder="Product Name" class="input-table" v-model="items.item_name"></el-input> -->
											<el-autocomplete class="input-table" v-model="invoiceForm.inv_items[index].itm_tittle"
												:fetch-suggestions="filterInvoiceCategory" placeholder="Type"
												@select="selectInvoiceCategory($event, index)"></el-autocomplete>
										</b-td>
										<b-td class="p-0 m-0">
											<el-autocomplete class="input-table" v-model="invoiceForm.inv_items[index].itm_prof_service"
												:fetch-suggestions="filterInvoiceProvesional" placeholder="List Of Profesional Service"></el-autocomplete>
										</b-td>
										<b-td class="p-0 m-0">
											<el-input placeholder="Description" class="input-table"
												v-model="invoiceForm.inv_items[index].itm_description"></el-input>
										</b-td>
										<b-td class="p-0 m-0">
											<CurrencyInput :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
												class="border-0" v-model="invoiceForm.inv_items[index].itm_amount" />
										</b-td>
										<b-td>
											<el-button class="m-0 p-0" @click="delRowItem(index)" type="button">
												<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
													<path fill="#DC3545"
														d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
												</svg>
											</el-button>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="p-0 m-0">
											<!-- <el-input placeholder="Product Name" class="input-table" v-model="items.item_name"></el-input> -->
											<el-autocomplete class="input-table" v-model="items.itm_tittle"
												:fetch-suggestions="filterInvoiceCategory" placeholder="Type" :trigger-on-focus="true"
												@select="selectInvoiceCategory"></el-autocomplete>
										</b-td>
										<b-td class="p-0 m-0">
											<el-autocomplete class="input-table" v-model="items.itm_prof_service"
												:fetch-suggestions="filterInvoiceProvesional" placeholder="List Of Profesional Service" :trigger-on-focus="true"
												></el-autocomplete>
										</b-td>
										<b-td class="p-0 m-0">
											<el-input placeholder="Description" class="input-table"
												v-model="items.itm_description"></el-input>
										</b-td>
										<b-td class="p-0 m-0">
											<CurrencyInput :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
												class="border-0" v-model="items.itm_amount" />
										</b-td>
										<b-td>
											<el-button class="m-0 p-0" @click="addRowItem" type="button"
												:disabled="(items.itm_amount === '' || items.itm_name === '')">
												<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
													<path fill="#28A745"
														d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
												</svg>
											</el-button>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td colspan="3" style="border: none;" class="text-right font-weight-700">SubTotal</b-td>
										<b-td class="font-weight-700">RM {{ currTotalAmount | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td colspan="3" class="text-right">Tax</b-td>
										<b-td>RM {{ invoiceForm.inv_tax_amount | moneyFormatter }}</b-td>
									</b-tr>
									<b-tr>
										<b-td colspan="3" style="font-size: 16px;" class="text-right font-weight-600">Total</b-td>
										<b-td style="font-size: 16px;" class="font-weight-600">RM {{ currTotalAmount | moneyFormatter
										}}</b-td>
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</div>

						<b-form-group label="Remarks" class="my-2">
							<el-input type="textarea" rows="4" v-model="invoiceForm.inv_remark">
							</el-input>
						</b-form-group>

						<b-row class="mt-1 pt-4 pb-5 text-center w-100">
							<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
								<b-button variant="primary" type="submit" class="w-100" :disabled="invalid && checkItems || ((!(invalid && checkItems)) && is_loading_btn)">{{ is_update ? 'Update' :
									'Create'}}</b-button>
							</b-col>
						</b-row>
					</b-form>
				</ValidationObserver>
			</b-container>
			<PreviewModal ref="preview_modal"></PreviewModal>
		</el-drawer>
	</div>
</template>

<script>
import { Drawer, Button, Select, Option, DatePicker, Table, TableColumn, Autocomplete, Input } from 'element-ui'

import { axios, services, getHeader } from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useBillingStore } from '@/stores/billingStore'
import CurrencyInput from '@/components/CurrencyInput'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ShareInvoiceModal from '@/views/Sales/ProFormaInvoices/Modals/ShareInvoiceModal.vue'
import PreviewModal from '@/components/Modal/PreviewModal'
import _ from 'lodash'

export default {
	components: {
		CurrencyInput,
		ShareInvoiceModal,
		PreviewModal,
		ValidationObserver,
		ValidationProvider,
		[Drawer.name]: Drawer,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
		[Input.name]: Input,
		[Autocomplete.name]: Autocomplete,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			is_visible: false,
			is_update: false,
			is_loading_opt: false,
			is_loading_btn: false,
			tableData: [],
			paymentDetail: {},
			invoiceForm: {
				inv_id: null,
				inv_user_id: null,
				inv_user_type: null,
				inv_user_name: null,
				inv_user_email: null,
				inv_user_mobile: null,
				inv_stm_id: null, //if set will check existing
				inv_scrb_id: null, //if set will check existing
				inv_pckg_id: null, //if set will check existing
				inv_title: null,
				inv_description: null,
				inv_ref_no: null, //if null will auto generate
				inv_issued_date: null,
				inv_status: "DRAFT", //DRAFT,ISSUED,PAID,CANCELED
				inv_tax_amount: 0,
				inv_remark: null,
				inv_items: [
				],
			},
			items: {
				itm_tittle: "",
				itm_prof_service: "",
				itm_description: "",
				itm_amount: "",
				itm_qty: "1",
			},
			modals: {
				show_share_invoice: false
			},
			customerOptions: [],
			invoiceCategoriesOptions: []
		}
	},
	created() {
		this.getInvoiceCategoryList()
	},
	computed: {
		currTotalAmount() {
			return this.invoiceForm.inv_items.reduce((total, row) => total + parseFloat(row.itm_amount), 0);
		},
		checkItems() {
			if (this.invoiceForm.inv_items.length > 0) {
				return false
			}
			return true
		}
	},
	methods: {
		...mapActions(useBillingStore, ['createInvoicePdf', 'getInvoiceCategories', 'sendInvoiceToEmail', 'createInvoice', 'createPayment', 'updateInvoice', 'getPayments']),
		show(data = null) {
			if (!_gHlp.isEmpty(data)) {
				this.is_update =  (_gHlp.getValue(data,'inv_id',0) > 0) ? true : false
				this.customerOptions.push({
					customer_id: _gHlp.getValue(data, 'inv_user_id'),
					name: _gHlp.getValue(data, 'inv_user_name'),
					email: _gHlp.getValue(data, 'inv_user_email'),
					contact_no: _gHlp.getValue(data, 'inv_user_mobile'),
					nric: _gHlp.getValue(data, 'inv_user_ic')
				})
				this.invoiceForm = { ...this.invoiceForm, ...data };
				this.getCustomers(data.inv_user_name)
				this.checkPayment()
			}
			this.is_visible = true
		},
		hide() {
			this.is_visible = false
			this.is_update = false
			this.invoiceForm = {
				inv_id: null,
				inv_user_id: null,
				inv_user_type: null,
				inv_user_name: null,
				inv_user_email: null,
				inv_user_mobile: null,
				inv_user_ic: null,
				inv_stm_id: null, //if set will check existing
				inv_scrb_id: null, //if set will check existing
				inv_pckg_id: null, //if set will check existing
				inv_title: null,
				inv_description: null,
				inv_ref_no: null, //if null will auto generate
				inv_issued_date: null,
				inv_status: "DRAFT", //DRAFT,ISSUED,PAID,CANCELED
				inv_remark: null,
				inv_items: [
				],
			}
			this.items = {
				itm_tittle: "",
				itm_prof_service: "",
				itm_description: "",
				itm_amount: "",
				itm_qty: "1",
			}
			this.$emit('close')
		},
		submit() {
			this.is_loading_btn = true;
			if (this.is_update) {

				let formData = _.cloneDeep(this.invoiceForm)
				delete formData.inv_id

				this.updateInvoice(this.invoiceForm.inv_id, formData)
					.then(res => {
						this.hide()
						_gNotif.notifySuccess('<b>Invoice : ' + res.inv_ref_no + '</b> - Successfully Updated.')
						this.$emit('getInvoice')
						this.is_loading_btn = false;
					})
					.catch(e => {
						this.is_loading_btn = false;
						_gNotif.errorFunction(e)
					})

			} else {

				const _selId = this.invoiceForm.inv_user_id;
				const selectedCustomer = this.customerOptions.find((itm) => { return itm.customer_id == _selId });
				this.invoiceForm.inv_user_name = _gHlp.getValue(selectedCustomer, 'name')
				this.invoiceForm.inv_user_email = _gHlp.getValue(selectedCustomer, 'email')
				this.invoiceForm.inv_user_mobile = _gHlp.getValue(selectedCustomer, 'contact_no')
				this.invoiceForm.inv_user_ic = _gHlp.getValue(selectedCustomer, 'nric')
				this.invoiceForm.inv_user_type = "customer"
				let formData = this.invoiceForm
				formData['inv_application_code'] = _gAuth.appCode()
				formData['inv_corporate_id'] = _gAuth.activeCorporateId()

				if(_gHlp.isEmpty(formData.inv_ref_no)){
					formData.inv_ref_no = 'INV_PROFORMA_'+_gHlp.formatDate(_gHlp.getCurrentDateTime(),'YmdHis')
				}

				this.createInvoice(formData).then(res => {
						this.hide()
						_gNotif.notifySuccess('<b>Invoice : ' + res.inv_ref_no + '</b> - Successfully Created.')
						EventBus.$emit('refresh-invoice-list')
						this.is_loading_btn = false;
					})
					.catch(e => {
						this.is_loading_btn = false;
						_gNotif.errorFunction(e)
					})
			}

		},
		addRowItem() {
			this.invoiceForm.inv_items.push(this.items)
			this.items = {
				itm_tittle: "",
				itm_prof_service: "",
				itm_description: "",
				itm_amount: "",
				itm_qty: "1",
			}
		},
		delRowItem(idx) {
			this.invoiceForm.inv_items = this.invoiceForm.inv_items.filter((itm, index) => { return index != idx })
		},

		checkPayment() {
			const params = {
				search: {
					pay_inv_id: this.invoiceForm.inv_id
				}
			}
			this.getPayments(params).then((resp) => {
				this.paymentDetail = _gHlp.getValue(resp, 'content.0')
			}).catch(e => {
				_gNotif.errorFunction(e)
			})
		},
		remoteMethod(query) {
			if (query !== '') {
				this.getCustomers(query);
			}
		},
		getCustomers(name) {
			this.is_loading_opt = true;
			axios.get(services.customer + 'customers', {
				params: {
					name: name,
					paginate: 10
				},
				headers: getHeader()
			})
				.then(res => {
					this.customerOptions = _gHlp.getValue(res, 'data.data.data', [])
					this.is_loading_opt = false;
				})
				.catch(e => {
					this.customerOptions = []
					this.is_loading_opt = false;
				})
		},
		getInvoiceCategoryList() {
			this.getInvoiceCategories({
				search: {
					corporate_id: _gAuth.activeCorporateId()
				},
				pagination: {
					page: 'no_pagination'
				}
			}).then((resp) => {
				const results = _gHlp.getValue(resp, 'content', [])
				this.invoiceCategoriesOptions = results
			})
		},
		filterInvoiceCategory(queryString, cb) {
			const sources = _.cloneDeep(this.invoiceCategoriesOptions)
			let result = [];
			if (queryString) {
				result = sources.filter((item) => { return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0); })
			}else{
				result = sources;
			}
			result.forEach(element => {
				element['value'] = element.name
			});
			cb(result)
		},
		filterInvoiceProvesional(queryString,  cbx) {
			const sources = _.cloneDeep(this.invoiceCategoriesOptions)
			let result = [];
			if (queryString) {
				result = sources.filter((item) => { return (item.description.toLowerCase().indexOf(queryString.toLowerCase()) === 0); })
			}else{
				result = sources;
			}
			result.forEach(element => {
				element['value'] = element.description
			});

			cbx(result)
		},
		selectInvoiceCategory(item, index = null) {
			if (_gHlp.isEmpty(index)) {
				this.items.itm_amount = item.amount
			} else {
				this.invoiceForm.inv_items[index].itm_amount = item.amount
			}
		},
		generatePayment() {
			this.is_loading_btn = true;
			const params = {
				pay_type: 'DIRECT_PURCHASE',
				pay_user_email: this.invoiceForm.inv_user_email,
				pay_user_fullname: this.invoiceForm.inv_user_name,
				pay_user_mobile: this.invoiceForm.inv_user_mobile,
				pay_user_ic: this.invoiceForm.inv_user_ic,
				pay_description: this.invoiceForm.inv_description,
				pay_inv_id: this.invoiceForm.inv_id,
				pay_amount_before: this.invoiceForm.inv_total_before,
				pay_amount_tax: this.invoiceForm.inv_tax_amount,
				pay_amount_total: this.invoiceForm.inv_total_payment,
				pay_redirect_url: window.location.origin + '/proFormaInvoices',
				pay_callback_url: null
			}
			this.createPayment(params)
				.then(res => {
					this.checkPayment()
					this.is_loading_btn = false;
				})
				.catch(e => {
					this.is_loading_btn = false;
					_gNotif.errorFunction(e)
				})
		},
		generatePdf() {
			this.createInvoicePdf(this.invoiceForm.inv_id, {})
				.then(res => {
					this.$refs.preview_modal.preview(res.data.url)
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
		},
		sendToEmail() {
			this.is_loading_btn = true;
			this.sendInvoiceToEmail(this.invoiceForm.inv_id, {})
				.then(res => {
					if(this.invoiceForm.inv_status == 'DRAFT') {
						this.invoiceForm.inv_status = 'ISSUED';
						this.submit()

						// //GENERATE OR COPY TO NEW INVOICE
						// let formData = this.invoiceForm
						// delete formData.inv_id;
						// formData.inv_ref_no = 'INV_CPYPRFM_'+this.invoiceForm.inv_id+'_'+_gHlp.formatDate(_gHlp.getCurrentDateTime(),'YmdHis')
						
						// this.createInvoice(formData).then(res => {
						// 	_gNotif.notifySuccess('<b>Invoice : ' + res.inv_ref_no + '</b> - Successfully Created.')
						// 	EventBus.$emit('refresh-invoice-list')
						// 	this.hide()
						// 	this.is_loading_btn = false;
						// })
						// .catch(e => {
						// 	this.is_loading_btn = false;
						// 	_gNotif.errorFunction(e)
						// })
					}	
					this.is_loading_btn = false;
					_gNotif.notifySuccess('<b>Email</b> - Has Been Send Successfully.')
				})
				.catch(e => {
					this.is_loading_btn = false;
					_gNotif.errorFunction(e)
				})
		}
	}
}
</script>
